export default {
  // 模式
  "common.mode.auto": "Avtomatski način uporabe proizvedene energije",
  "common.mode.economy": "Ekonomski način",
  "common.mode.exigency": "Nadzorni način",

  // 设备
  "common.grid": "Električna mreža",
  "common.evChargers": "Punjači za električna vozila",
  "common.evCharger": "Punjac za električno vozilo",
  "common.pv": "Fotovoltaika (PV)",
  "common.inverter": "Inverter",
  "common.pcs": "Inverter + baterija",
  "common.terminal": "Terminalno napravo",
  "common.airc": "Klimatska naprava",
  "common.engine": "Motor",
  "common.battery": "Baterija",
  "common.metter": "Električni merilnik",
  "common.other": "Ostalo",
  "common.power": "Moč",
  "common.powerTotal": "Skupna moč",
  "common.voltage": "Napon",
  "common.electricity": "Električna energija",
  "common.current": "Tok",
  "common.homeUsage": "Skupno obremenitev doma",
  "common.battery.power": "Moč baterije",

  // 数据
  "common.noDataAvailable": "Trenutno ni podatkov~",
  "common.tips": "Namig",
  "common.reset": "Ponastavi",
  "common.currencyUnit": "¥",
  "common.submiting": "Pošiljanje... Prosimo, počakajte...",
  "common.close": "Zapri",
  "common.from": "Iz",
  "common.useIn": "Za",
  "common.energyPercent": "Procent pretoka energije",
  "common.dataFlow": "Tok podatkov",
  "common.getDataIng": "Pridobivanje podatkov... Prosimo, počakajte...",
  "common.pageLoading": "Nalaganje vsebine strani... Prosimo, počakajte...",
  "common.reseting": "Ponastavljanje vsebine strani... Prosimo, počakajte...",
  "common.save": "Shrani",
  "common.onlyNumberTips": "Lahko vnesete samo številke",
  "common.offline": "Nadomestno",
  "common.online": "Spletno",
  "common.fault": "Napaka",
  "common.charge": "Napolnitev",
  "common.discharge": "Razpolnitev",
  "common.buy": "Kupi",
  "common.sell": "Prodaj",
  "common.loadingInfo": "Nalaganje... Prosimo, počakajte...",

  // 
  "common.moreFeatures": "Več funkcij",
  "common.confirm": "Potrdi",
  "common.saveing": "Shranjevanje... Prosimo, počakajte...",
  "common.searchPlacholder": "Vnesite iskalni niz",
  "common.iSee": "Razumem",
  "common.pageErrorTips1": "Oh, na strani je prišlo do napake~",
  "common.pageErrorTips2": "Poskusite osvežiti stran ali se obrnite na podporo~",
  "common.refresh": "Osveži",
  "common.backToHome": "Nazaj na domačo stran",
  "common.checkTips": "Preverjanje... Prosimo, počakajte...",
  "common.back": "Nazaj",
  "common.cancel": "Prekliči",
  "common.optional": "Izbirno",
  "common.required": "Obvezno",
  "common.status": "Stanje",
  "common.statusNoDelete": "Ni izbrisan",
  "common.statusDelete": "Izbrisan",
  "common.submit": "Pošlji",
  "common.disable": "Onemogoči",
  "common.enable": "Omogoči",
  "common.year": "leto",
  "common.month": "mesec",
  "common.day": "dan",
  "common.version": "Različica:",
  "common.backHome": " Nazaj na domačo stran",
  "common.backHomeSorry": " Žal je stran naključno izgubila pot",
  "common.requestTips1": "Obdelava podatkov je v teku, ne pošiljajte ponovno",
  "common.requestTips2": "Sistemske obvestila",
  "common.requestTips3": "Stanje prijave je poteklo, prosimo, prijavite se znova",
  "common.requestTips4": "Ponovna prijava",
  "common.requestTips5": "Neveljavna seja ali seja je potekla, prosimo, prijavite se znova.",
  "common.requestTips6": "Napaka strežnika, prosim poskusite kasneje.",
  "common.requestTips7": "Čas trajanja zahteve za sistemski vmesnik je potekel",
  "common.requestTips8": "Sistemski vmesnik",
  "common.requestTips9": "Napaka",
  "common.iknow": "Razumem",
  "common.logoutSuccess": "Uspešna odjava",
  
  // 了解更多组件
  "common.knowMore.title": "Za več informacij se obrnite na Beineng",
  "common.knowMore.email": "Kontaktni e-pošta",
  "common.knowMore.phone": "Kontaktni telefon",
  "common.knowMore.wechat": "Kontaktni WeChat",
  "common.knowMore.website": "Naslov uradne spletne strani",
  "common.knowMore.address": "Kontaktna naslov",
  "common.knowMore.addressDetail": "Soba 1205 in 1301, stavba 5, Qinghe ulica 8, Huangjingkeng sela, Huangjiang mestna občina, Dongguan mesto, Guangdong province",
  
  // 本地连接组件
  "common.localConnection": "Lokalna povezava",
  "common.operateInApp": "Izvedite dejanje v aplikaciji!",
  
  "common.enbleStaus": "Stanje omogočanja",
  "common.battery.status": "Brez napolnitve in razpolnitve",

  "account.forgetThePassword": "Pozabljeno geslo",
  "account.logInDirectly": "Prijavite se takoj",
  "account.tips1": "Preusmerjanje na stran... Prosimo, počakajte...",
  "account.tips2": "Najprej preberite in sprejmite pogoje uporabe!",
  "account.autoLogin": "Samodejna prijava",
  "account.userLogin": "Prijava uporabnika",
  "account.registerTips": "Še nimate računa? Kliknite tukaj za registracijo",
  "account.userEmail": "Uporabniško ime / e-pošta",
  "account.userEmailTips": "Vnesite uporabniško ime ali e-pošto",
  "account.password": "Geslo",
  "account.passwordTips": "Vnesite geslo",
  "account.submit": "Pošlji",
  "account.submitTips": "Pošiljanje... Prosimo, počakajte...",
  "account.otherLoginTips": "Ali izberite drugo metodo prijave",
  "account.userRegistration": "Registracija uporabnika",
  "account.userName": "Uporabniško ime",
  "account.userNameTips": "Vnesite uporabniško ime",
  "account.emailTips1": "Vnesite e-poštni naslov",
  "account.emailTips2": "Neveljaven format e-pošte",
  "account.phone": "Telefonska številka",
  "account.phoneTips1": "Vnesite telefonsko številko",
  "account.phoneTips2": "Neveljavna telefonska številka",
  "account.phoneTips3": "Vnesite telefonsko številko",
  "account.passwordTips1": "Vnesite geslo (6-30 znakov)",
  "account.passwordTips2": "Neveljaven format gesla: geslo mora vsebovati angleške črke, številke, podčrtaje, črtice in pike, dolžina 6-12 znakov",
  "account.passwordTips3": "Dva vnesena gesla se ne ujemata, prosimo, preverite in vnesite znova!",
  "account.passwordTips4": "Vnesite geslo: geslo mora vsebovati angleške črke, številke, podčrtaje, črtice in pike",
  "account.passwordTips5": "Potrditev gesla",
  "account.passwordTips6": "Vnesite potrditev gesla",
  "account.passwordTips7": "Dva vnesena gesla se ne ujemata, prosimo, preverite in vnesite znova!",
  "account.passwordTips8": "Vnesite potrditev gesla",
  "account.passwordTips9": "Čestitamo, registracija je uspešna!",
  "account.passwordTips10": "Vaše uporabniško ime je:",
  "account.emailIs": "E-pošta je:",
  "account.goToLoginPage": "Čez s sekund bo avtomatično preusmerjeno na stran prijave",
  "account.goLogin": "Prijava",
  "account.goRegister": "Registracija",
  "account.loginSuccess": "Uspešna prijava",
  "account.email": "E-pošta",
  "account.sologn": "Z pazljivostjo ustvarjamo prilagojeni energijski načrt za vas",
  "account.pleaseAgree": "Prebral sem in sprejel",
  "userAgreement.privacyPolicy": "politiko zasebnosti",

  "account.code": "Potrditveni kod",
  "account.codeTips": "Vnesite potrditveni kod",
  "account.codeTips2": "Neveljaven potrditveni kod",

    "account.inviteCodeTips": "Prosimo, vnesite kodo povabila",
    "account.inviteCodeHint": "Za pridobitev kode povabila se obrnite na monterja ali vzdrževalno osebje",
  "account.modifyPasswordByAccount": "Sprememba gesla preko računa",
  "account.modifyPasswordByEmail": "Sprememba gesla preko e-pošte",
  "account.getPasswordByAccount": "Pridobitev gesla preko računa",
  "account.getPasswordByEmail": "Pridobitev gesla preko e-pošte",

  "account.sendEmailTips": "Potrditveni kod je poslan na e-pošto, prosimo, preverite",
  "account.name": "Ime računa",
  "account.newPassword": "Novo geslo",
  "account.confirmNewPassword": "Potrditev novega gesla",
  "account.nameTips": "Vnesite ime računa",
  "account.passwordModifySuccess": "Uspešna sprememba gesla",
  "account.emailCode": "E-poštni potrditveni kod",
  "account.emailCodeTips": "Vnesite e-poštni potrditveni kod",
  "account.emailCodeTips2": "Neveljaven e-poštni potrditveni kod",
  "account.emailModifySuccess": "Uspešna sprememba gesla",
  "account.passworTips1": "Vaše geslo je uspešno ponastavljeno!",
  "account.passwordTips11": "Vnesite potrditev gesla",
  "account.passwordTips12": "Vnesite novo geslo",
  "account.nickname": "Vzdevek uporabnika",
  "account.modifyNickname": "Sprememba vzdevka uporabnika",
  "account.modifyNicknameSuccess": "Uspešna sprememba vzdevka uporabnika!",
  "account.nicknameTips": "Vnesite vzdevka uporabnika",
  "account.nicknameError": "Neuspešna sprememba vzdevka uporabnika!",

  "account.login": "Prijava",
  "account.quickRegister": "Hitra registracija",
  "account.sendCode": "Pošlji kodo",
  "account.sendTips": "Po s sekundah lahko pošljete znova",
  "account.sendEmailIng": "Pošiljanje e-pošte... Prosimo, počakajte...",
  "account.emailNotEmpty": "E-poštni naslov ne sme biti prazen",
  "account.registerAccount": "Registracija računa",
  "account.registerWelcome": "Dobrodošli v registraciji SusprSafe",
  "account.usernameLimit": "Uporabniško ime mora začeti z črko in lahko vsebuje samo črke, številke in podčrtaje, dolžina 5-15 znakov",

  "copyright.desc2": "Informacije o registraciji spletne strani: Registracija ICP Guangdong številka 2021169764",

  "editUserInfo.editUserInformation": "Urejanje informacij uporabnika",
  "editUserInfo.modifyUsername": "Sprememba uporabniškega imena",
  "editUserInfo.changePictures": "Sprememba profilne slike",
  "editUserInfo.savePicturesSuccess": "Profilna slika uporabnika je uspešno shranjena",
  "editUserInfo.saveError": "Shranjevanje ni uspelo",
  "editUserInfo.pictureLimit": "Velikost slike mora biti manjša od 2 MB",
  "editUserInfo.uploadPicture": "Naložite profilno sliko",
  "editUserInfo.picturePreview": "Predogled",
  
  "editUserInfo.bindPhoneNumber": "Povezava telefonske številke",
  "editUserInfo.bindEmail": "Povezava e-pošte",
  "editUserInfo.changePassword": "Sprememba gesla",

  "editUserInfo.notificationSettings": "Nastavitve obvestil",
  "editUserInfo.editAccount": "Urejanje informacij o uporabniškem računu",
  "editUserInfo.waitBingting": "Povezovanje... Prosimo, počakajte...",
  "editUserInfo.collapse": "Strni",
  "editUserInfo.modifyBinding": "Sprememba povezave",
  
  "editUserInfo.emailAddress": "E-poštni naslov",
  "editUserInfo.tips1": "Uspešna povezava e-pošte",
  "editUserInfo.tips2": "Shranjevanje ni uspelo",
  "editUserInfo.tips3": "Pošiljanje e-poštnega potrditvenega koda... Prosimo, počakajte...",
  "editUserInfo.tips4": "Potrditveni kod je poslan na e-pošto xxxx, prosimo, preverite",
  "editUserInfo.tips5": "Pošiljanje potrditvenega koda ni uspelo!",
  "editUserInfo.tips6": "Telefonska številka je že povezana",
  "editUserInfo.tips7": "E-pošta je že povezana",
  "editUserInfo.emailTips1": "Vnesite e-poštni naslov",
  "editUserInfo.emailTips2": "Neveljaven format e-pošte",
  "editUserInfo.emailTips3": "Po xxxx sekundah lahko pošljete znova",
  "editUserInfo.emailTips4": "Pošlji kodo",
  "editUserInfo.emailTips5": "E-poštni potrditveni kod ne sme biti prazen",
  "editUserInfo.emailTips6": "Neveljaven e-poštni potrditveni kod",
  "editUserInfo.emailCode": "E-poštni potrditveni kod",
  "editUserInfo.save": "Shrani",

  "editUserInfo.phoneTips1": "Uspešna povezava telefonske številke",
  "editUserInfo.phoneTips2": "Pošiljanje SMS potrditvenega koda... Prosimo, počakajte...",
  "editUserInfo.phoneTips3": "SMS potrditveni kod je poslan na telefonsko številko xxxx, prosimo, preverite",
  "editUserInfo.phoneTips4": "Pošiljanje SMS potrditvenega koda ni uspelo!",
  "editUserInfo.phoneTips5": "Vnesite telefonsko številko",
  "editUserInfo.phoneTips6": "Neveljaven format telefonske številke",
  "editUserInfo.phoneTips7": "Pošlji SMS potrditveni kod",
  "editUserInfo.phoneTips8": "SMS potrditveni kod",
  "editUserInfo.phoneTips9": "SMS potrditveni kod ne sme biti prazen",
  "editUserInfo.phoneTips10": "Neveljaven SMS potrditveni kod",
  "editUserInfo.phone": "Telefonska številka",


  "editUserInfo.noticeTips1": "Pridobitev nastavitev obvestil ni uspelo!",
  "editUserInfo.noticeTips2": "Nastavitve obvestil so uspešno shranjene!",
  "editUserInfo.noticeTips3": "Obvestilo o nizkem nivoju baterije",
  "editUserInfo.noticeTips4": "Obvestilo o koncu polnjenja punjača",
  "editUserInfo.errorNotification": "Obvestilo o napaki",
  "editUserInfo.updateNotification": "Obvestilo o posodobitvi",
  "editUserInfo.monthlyStatisticsNotification": "Obvestilo o mesečnih statistikah",
  "editUserInfo.notificationMethod": "Način prejemanja",

  "editUserInfo.userNameTips1": "Uporabniško ime je uspešno shranjeno",
  "editUserInfo.userNameTips2": "Shranjevanje uporabniškega imena ni uspelo",
  "editUserInfo.userNameTips3": "Vnesite uporabniško ime",
  "editUserInfo.userNameTips4": "Neveljaven format uporabniškega imena: lahko vsebuje samo številke, podčrtaje in angleške črke",
  "editUserInfo.userNameTips5": "Vnesite uporabniško ime",
  "editUserInfo.userNameTips6": "Shranjevanje... Prosimo, počakajte...",
  "editUserInfo.userName": "Uporabniško ime",

  "editUserInfo.avatorTips": "Kliknite za spremembo profilne slike",
  "editUserInfo.verifyCodeTips1": "Vnesite prejete potrditveni kod:",
  "editUserInfo.verifyCodeTips2": "Za varnost vašega računa kliknite gumb spodaj, da pošljete potrditveni kod na originalno telefonsko številko:",
  "editUserInfo.verifyCodeTips3": "Pošlji kodo",
  "editUserInfo.verifyCodeTips4": "Preverjanje originalne telefonske številke je uspešno, vnesite novo povezano telefonsko številko",
  "editUserInfo.verifyCodeTips5": "Za varnost vašega računa kliknite gumb spodaj, da pošljete potrditveni kod na originalno e-pošto:",
  "editUserInfo.verifyCodeTips6": "Preverjanje originalne e-pošte je uspešno, vnesite novo e-pošto",
  "editUserInfo.verifyCodeTips7": "Staro geslo",
  "editUserInfo.verifyCodeTips8": "Najprej povežite e-pošto!",
  "editUserInfo.verifyCodeTips9": "Potrditveni kod je poslan na e-pošto, prosimo, preverite",
  "editUserInfo.verifyCodeTips10": ", bo avtomatično preusmerjeno na stran prijave",

  "hems.notice.title": "Naslov obvestila", 
  "hems.notice.content": "Vsebina obvestila", 
  "hems.notice.operate": "Dejanje",
  "hems.notice.noRead": "Neprebrano",
  "hems.notice.read": "Prebrano",
  "hems.notice.warning": "Opozorilo",
  "hems.notice.error": "Napaka",
  "hems.notice.success": "Statistično računanje",
  "hems.notice.sys": "Sistemske informacije",
  "hems.notice.operateSuccess": "Uspešno dejanje",
  "hems.notice.operateTips": "Izberite element za dejanje",

  // 首页
  "hems.home.selfuseRate": "Stopnja samostojne uporabe",
  "hems.home.percent": "Procent",
  "hems.home.todayData": "Danesnji podatki",
  "hems.home.todayPowerGeneration": "Danesnja proizvodnja energije",
  "hems.home.salesIncome": "Prihodki z prodaje energije",
  "hems.home.saved": "Varčili ste",
  "hems.home.reduce": "Zmanjšajte ogljikov odtis",
  "hems.home.tips1": "Trenutno ni podatkov, še niste povezali xxxx",
  "hems.home.criticalLoad": "Kritična obremenitev",
  "hems.home.keyVoltage": "Kritični napon",
  "hems.home.householdLoad": "Obremenitev doma",
  "hems.home.householdVoltage": "Napon doma",
  "hems.home.generalLoad": "Običajna obremenitev",
  "hems.home.generalVoltage": "Običajni napon",
  "hems.home.batteryHealth": "Stanje zdravja baterije",
  "hems.home.averageTemp": "Povprečna temperatura",
  "hems.home.gridLoad": "Obremenitev električne mreže",
  "hems.home.toggeleDataSource": "Trenutno prikazani podatki so spremenjeni v:",
  "hems.home.toggleTips": "Ste prepričani, da želite spremeniti?",
  "hems.home.modeSending": "Pošiljanje ukaza za način... Prosimo, počakajte...",
  "hems.home.modeSuccess": "Ukaz za spremembo načina je uspešno poslan!",
  "hems.home.isOnline": "Ali je spletno?",
  "hems.home.useStatus": "Stanje uporabe",
  "hems.home.workModeText": "Trenutni način delovanja:",
  "hems.home.toggleDataSourceText": "Trenutno prikazani podatki so spremenjeni v:",
  "hems.ev.charge.status": "Stanje polnjenja",
  "hems.ev.charge.time": "Čas polnjenja",
  "hems.ev.charge.count": "Dejanska količina polnjenja",
  "hems.ev.charge.status.empty": "Prazno",
  "hems.ev.charge.status.ing": "Napolnjevanje z povezanim kabli",
  "hems.ev.charge.status.null": "Kabel je povezan, vendar se ne napolni",
  "hems.ev.charge.status.error": "Napaka",
  "hems.hour": "ura",
  "hems.minue": "minuta",
  "hems.ev.chagre.number": "Številka punjača",

  // User Guide
  "hems.userGuide.selfUse": "Samostojna uporaba proizvedene energije",
  "hems.userGuide.selfUseTips": "Prvi uporabite fotovoltaško energijo, če ni dovolj, napolnite iz električne mreže",
  "hems.userGuide.economyMode": "Ekonomski način",
  "hems.userGuide.economyModeTips": "Optimizacija strategije uporabe energije glede na ceno električne energije",
  "hems.userGuide.emergencyMode": "Nadzorni način",
  "hems.userGuide.emergencyModeTips": "Prvi zagotovite oskrbo energije za kritično obremenitev",

  // 图表页面
  "hems.history.energyStatistics": "Statistika energije",
  "hems.history.revenueStatistics": "Statistika prihodkov",
  "hems.history.greenStatistics": "Zelena zmanjšanje emisij",
  "hems.history.revenueTitle": "Skupni prihodki z prodaje energije",
  "hems.history.savingsTitle": "Skupne varčevanje",
  "hems.history.carbonTitle": "Skupno zmanjšanje ogljikovih emisij",
  "hems.history.day": "dan",
  "hems.history.month": "mesec",
  "hems.history.year": "leto",
  "hems.history.beforeDay": "Prejšnji dan",
  "hems.history.afterDay": "Naslednji dan",
  "hems.history.beforeMonth": "Prejšnji mesec",
  "hems.history.afterMonth": "Naslednji mesec",
  "hems.history.beforeYear": "Prejšnje leto",
  "hems.history.afterYear": "Naslednje leto",
  "hems.history.totalUse": "Skupna uporaba",
  "hems.history.fullScreen": "Celoten zaslon",
  "hems.history.timeSelect": "Izbor datuma",
  "sync.tips1": "Ukaz za sinhronizacijo podatkov je uspešno poslan!",
  "sync.tips2": "Sinhronizacija podatkov je v teku, zaradi velikosti podatkov je potreben čas, preverite znova po pol ure~",
  "sync.tips3": "Sinhronizacija podatkov naprave lahko ima zamudo, če opazite neskladnosti v podatkih, kliknite na:",
  "sync.tips4": "Sinhroniziraj podatke",

  "charge.info": "Informacije o punjacu",
  "news.loading": "Nalaganje...",
  "news.noMore": "Ni več podatkov",
  "hems.pv.power": "Količina fotovoltaške energije",

  // UEH specific
  "ueh.sellPower": "Količina prodane energije",
  
  "menu.home": "Domača stran",
  "menu.history": "Zgodovinski podatki",
  "menu.device": "Naprave",
  "menu.settings": "Nastavitve",
  "menu.messageCenter": "Središče sporočil",
  "menu.help": "Pomoč in podporo",
  "menu.mine": "Moje",


  "mine.userSetting": "Nastavitve uporabnika",
  "mine.terminalSetting": "Osnovne nastavitve terminala",
  "mine.uploadCloud": "Naložitev podatkov v oblak",
  "mine.changeVersion": "Preverjanje posodobitev",
  "mine.language": "Sprememba jezika",
  "mine.about": "O aplikaciji",
  "mine.feedback": "Povratne informacije",
  "mine.logout": "Odjava",
  "mine.logoutAccount": "Brisanje računa",

  "mine.logoutAccountTips": "Brisanje računa z imenom []",
  "mine.logoutAccountTips1": "Brisanje računa povezanega z []",
  "mine.logoutAccountCare": "Opombe o zahtevi za brisanje računa:",
  "mine.logoutAccountCare1": "1. Račun je v varnem stanju",
  "mine.logoutAccountCare1-1": "Račun je v normalnem stanju uporabe, ni tveganja kraje, kršitve pravil ali blokiranja.",
  "mine.logoutAccountCare2": "2. Avtorizacije in povezave računa so bile odstranjene",
  "mine.logoutAccountCare2-1": "Vse avtorizacije računa z drugimi tretjimi stranmi so bile odstranjene.",
  "mine.logoutAccountCare3": "3. Po brisanju računa ga ni mogoče obnoviti, podatki uporabnika bodo izbrisani",
  "mine.logoutAccountCare3-1": "Po brisanju računa bodo povezane telefonske številke, e-pošte in drugi podatki izbrisani in jih ni mogoče obnoviti.",
  "mine.confirmLogout": "Potrdi brisanje",
  "mine.logoutSuccess": "Račun je uspešno izbrisan!",


  "mine.feedbackIssues": "Povratne informacije o težavah",
  "mine.feedQuantity": "Količina",
  "mine.feedAmount": "Največ 9 slik, največja velikost 1 MB/slika",

  "mine.notice.fail": "Pridobitev nastavitev obvestil ni uspelo!",
  "mine.notice.saveSuccess": "Nastavitve obvestil so uspešno shranjene!",
  "mine.notice.saveFail": "Shranjevanje ni uspelo!",
  "mine.notice.title": "Nastavitve obvestil",
  "mine.notice.batteryLow": "Obvestilo o nizkem nivoju baterije",
  "mine.notice.chargingFinish": "Obvestilo o koncu polnjenja punjača",
  "mine.notice.error": "Obvestilo o napaki",
  "mine.notice.update": "Obvestilo o posodobitvi",
  "mine.notice.monthly": "Obvestilo o mesečnih statistikah",
  "mine.notice.receiveType": "Način prejemanja",

  "mine.language.welcome": "Dobrodošli v SusprSafe",
  "mine.language.desc1": "Izberite jezikovno različico glede na vaše življenjsko mesto",
  "mine.language.desc2": "Lahko jo spremenite kadar koli v nastavitvah aplikacije",

  "mine.userInfo.avatar": "Profilna slika",
  "mine.userInfo.nickname": "Vzdevek",
  "mine.userInfo.password": "Geslo",
  "mine.userInfo.changePassword": "Sprememba gesla",
  "mine.userInfo.setPassword": "Nastavitev gesla",
  "mine.userInfo.phoneNumber": "Telefonska številka",
  "mine.userInfo.bindPhone": "Povezava telefonske številke",
  "mine.userInfo.bindEmail": "Povezava e-pošte",
  "mine.loginExpired": "Stanje prijave je poteklo, prosimo, prijavite se znova",
  "mine.userInfo.title": "Informacije o uporabniku",
  "mine.userInfo.bind": "Poveži",
  "mine.userInfo.modify": "Uredi",
  "mine.userInfo.modifyNickname": "Sprememba vzdevka",
  "mine.userInfo.userNickname": "Vzdevek uporabnika",
  "mine.userInfo.selectPic": "Izberite sliko za nalaganje",
  "mine.userInfo.saveSuccess": "Uspešno shranjeno",
  "mine.userInfo.uploadFail": "Nalaganje ni uspelo",
  "mine.userInfo.avatarSaveSuccess": "Profilna slika je uspešno shranjena",
  "mine.userInfo.nameTips1": "Vzdevek uporabnika ne sme biti prazen",
  "mine.userInfo.nameTips2": "Vnesite vzdevka uporabnika",

  "common.pleaseSelect": "Prosimo, izberite",
  "question.commonQuestions": "Pogosta vprašanja",
  "account.toggleLanguage": "Sprememba jezika",
  "account.localConnection": "Lokalna povezava",
  "account.selectLanguage": "Prosimo, izberite jezik",
  "account.sendEmailToast": "Potrditveni kod je poslan na e-pošto xxx, prosimo, preverite",
  "account.emailError": "Neveljaven format e-pošte",
  "account.sendEmailFail": "Pošiljanje ni uspelo, prosimo, poskusite znova",
  
  "common.submitting": "Pošiljanje... Prosimo, počakajte...",

  "device.page.noData": "Trenutno ni podatkov, to stran je mogoče videti samo v aplikaciji"
,

  // OTA Upgrade
  "bmsFirmware.upgrade": "Upgrade",
  "bmsFirmware.upgrading": "Upgrading...",
  "bmsFirmware.uploadingFile": "Uploading firmware file...",
  "bmsFirmware.upgradingProgress": "Upgrading firmware... {progress}%",
  "bmsFirmware.upgradeSuccess": "Upgrade Successful",
  "bmsFirmware.upgradeSuccessSubtitle": "BMS firmware upgrade completed!",
  "bmsFirmware.upgradeFailed": "Upgrade Failed",
  "bmsFirmware.upgradeFailedFormError": "Please check if the form is filled correctly",
  "bmsFirmware.upgradeFailedNetworkError": "Network error, please retry",
  "bmsFirmware.invalidFileType": "Please select a valid firmware file (.bin, .hex, .fw, .firmware)",
  "bmsFirmware.selectFileWarning": "Please select a firmware file first",
  "bmsFirmware.statusUpgrading": "Upgrading",
  "bmsFirmware.statusCompleted": "Upgrade Completed",
  "bmsFirmware.statusFailed": "Upgrade Failed",
  "bmsFirmware.deviceUpgrading": "Upgrading firmware package, upgrade takes 30 ~ 50 minutes, real-time device data cannot be viewed during this period, please wait...",
  "bmsFirmware.upgradeStatusLabel": "Upgrade Status",
  "bmsFirmware.upgradeProgressLabel": "Upgrade Progress",
  "bmsFirmware.currentPackageLabel": "Current transmitted data package number",
  "bmsFirmware.totalPackagesLabel": "Total data packages",
  "bmsFirmware.upgradeFailedCheckDevice": "Please check device status and retry upgrade",

  // Setting Result Dialog Translations
  "settingResult.defaultTitle": "Setting Successful",
  "settingResult.defaultSubTitle": "Parameter settings saved",
  "settingResult.confirmButton": "OK"
};